module.exports = __webpack_public_path__ + "static/media/lisa_portfolio.025b1c3a.jpg";